import React from 'react'
import styled from 'styled-components'
import { DashboardLayout } from '../../layouts'
import { Spinner } from '@mote/ui'
import { mote_primary } from '@mote/config/defaults/colors'

export const AccountLoadingState = () => {
  return (
    <DashboardLayout>
      <Root>
        <Spinner radius={100} color={mote_primary} />
      </Root>
    </DashboardLayout>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  margin: 15px;
`
